module.exports = __webpack_public_path__ + "static/img/mzhuanjia.a93a3a23.png";